import React, { useMemo } from 'react'
import { Stack } from '@mui/material'

import { useUser } from 'store'
import ScrollTable from 'components/global/CUK/ScrollTable'
import COLUMNS_CONFIG from './column-config'
import TableView, { useTable } from 'packages/ui/Table'
import ZeroStateMissingData from 'components/global/ZeroStateMissingData'
import EmptyScreen from 'packages/ui/EmptyScreen'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useSort, useItemsSelected } from '../store'
import { canSeeStimeFields } from '../permissions'
import { trackEvent } from 'analytics'

const Table = ({ apiRans }) => {
  const navigate = useNavigate()
  const [user] = useUser()
  const [sort, setSort] = useSort()
  const [itemsSelected, setItemSelected] = useItemsSelected()
  const { roomId } = useParams()
  const { t } = useTranslation()

  const columns = useMemo(() => {
    return COLUMNS_CONFIG.filter(({ name }) => {
      if (name === 'vlan') {
        return canSeeStimeFields(user)
      }
      return !roomId || (roomId && !['comments'].includes(name))
    })
  }, [roomId, user])

  const apiTable = useTable({
    rowKey: 'id',
    loading: apiRans.loading,
    loadingNext: apiRans.loadingNext,
    items: apiRans ? apiRans.rans : [],
    columns,
    onRowClick: ran => {
      if (itemsSelected.length) {
        if (itemsSelected.findIndex(({id}) => id === ran.id) > -1) {
          setItemSelected(prev => prev.filter(({id}) => id !== ran.id))
        } else {
          setItemSelected(prev => [...prev, ran])
        }
      } else {
        trackEvent('private_wifi_open_detail', { action_scope: 'item' })
        navigate(`./${ran.id}${window.location.search}`)
      }
    }
  })

  if (!apiRans.loading && !apiRans?.rans.length) {
    return <EmptyScreen>{t('ran.no_keys_created')}</EmptyScreen>
  }

  if (apiRans.error && apiRans.error.graphQLErrors && apiRans.error.graphQLErrors[0].extensions.code === 'NOT_FOUND') {
    return <ZeroStateMissingData message={t('ran.table.ran_site_not_activated')} iconlabel={'globe'} />
  }

  return (
    <Stack
      sx={{
        overflow: 'hidden',
        overflowY: 'auto',
        flex: '1 1 auto',
        scrollbarWidth: 'none',
        height: '100%',
        '&::-webkit-scrollbar ': {
          display: 'none'
        }
      }}
    >
      <ScrollTable
        fetchNextPage={apiRans.fetchNextPage}
        shouldFetchNextPage={apiRans.shouldFetchNextPage}
        collapse={roomId || itemsSelected.length}
      >
        <TableView
          apiTable={apiTable}
          sort={{
            ...sort,
            onChange: name => {
              const column = columns.find(column => column.name === name)
              setSort(column.sortBy || column.name)
            }
          }}
        />
      </ScrollTable>
    </Stack>
  )
}

export default Table
